export function getMonthName(data: {
  amount: string
  year: number
  month: number
}): string {
  const date = new Date(data.year, data.month - 1)

  return new Intl.DateTimeFormat('ru', { month: 'long' }).format(date)
}
